import { DataServer } from "../../../../config.axios";
import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { toggleLoading } from "../../LoadingSlice";
import { toast } from "react-toastify";

interface UpdateEmailNotificationUserDataState {
    updateemailnotificationuserdata: {
        load: boolean;
        data: any;
        error: any;
    };
}

export const UpdateNotificationSlice = createSlice({
    name: "updateemailnotificationuserdata",
    initialState: {
        updateemailnotificationuserdata: {
            load: false,
            data: [],
            error: [],
        },
    } as UpdateEmailNotificationUserDataState,
    reducers: {
        NotificationUserError: (state: UpdateEmailNotificationUserDataState, action: any) => {
            state.updateemailnotificationuserdata.error = action.payload;
        },
    },
});

export const { NotificationUserError } = UpdateNotificationSlice.actions;
export default UpdateNotificationSlice.reducer;

export const editNotificationUser = createAsyncThunk(
    "notificationusers/editNotificationUser",
    async (param: { apiParam: any, navigation: any }, thunkAPI) => {
        try {
            thunkAPI.dispatch(toggleLoading());
            const { data } = await DataServer.post(
                "api/PostAddNotificationUser",
                param.apiParam
            );

            thunkAPI.dispatch(toggleLoading());

            toast.success(data.message,{theme: "colored", onClose: () => {handleonConfirm();}});

            const handleonConfirm = () => {
                param.navigation("/escalation-matrix", {state: {from: "users"}});
            };
            return data.data;
        } catch (error: any) {
            thunkAPI.dispatch(toggleLoading());
            thunkAPI.dispatch(UpdateNotificationSlice.actions.NotificationUserError(error));
            return thunkAPI.rejectWithValue(error);
        }
    }
);
